<template>
	<div class="detail">
		<div class="top qjc-flex qjc-relative">
			<video :poster="videoPoster" :src="videoSrc" controls></video>
			<ul>
				<li class="title">
					<h3>{{ name }}</h3>
					<p>
						<span v-if="beginDay > 0">{{ beginDay }}天后进行</span>
						<span v-if="beginDay == 0">正在进行</span>
						<span v-else>已结束</span>
						{{ number }}人参加
					</p>
				</li>
				<li class="qjc-flex">
					<!-- <img @load="imgLoad" class="head qjc-hide" :src="doctor.avatar" :alt="doctor.name"> -->
					<dl>
						<dt>{{ doctor.name }}</dt>
						<dd>{{ doctor.title }}</dd>
					</dl>
				</li>
				<li>
					<div :class="{ open: showDes }" class="describe">
						{{ doctor.description }}
					</div>
					<span @click="showDes = true" v-if="!showDes" class="toggle">展开</span>
					<span @click="showDes = false" v-if="showDes" class="toggle">收缩</span>
				</li>
			</ul>
			
			<div @click="beginDay > 0?'':$router.push('/dayu/course/start/'+$route.params.id)" class="start qjc-absolute">
				开启课程计划
			</div>
		</div>
		
		<dl>
			<dt>课程简介</dt>
			<dd>{{ description }}</dd>
		</dl>
		
		<dl>
			<dt>适用人群</dt>
			<dd>{{ suitableCrowd }}</dd>
		</dl>
		
		<dl>
			<dt>课程介绍</dt>
			<dd>
				<span>总课数：{{ courseNumber }}节</span>
				<span>开课时间：{{ courseTime }}</span>
				<span>每课时长：{{ courseDuration }}</span>
			</dd>
		</dl>
		
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Toast } from 'vant'
	Vue.use(Toast);
	
	import { courseDetail } from "@/utils/axios"
	
	export default{
		name: 'dayuCourseDetail',
		data() {
			return {
				showDes: false,
				
				videoSrc: '',
				videoPoster: '',
				
				name: '',//课程标题
				number: 0,//参加人数
				beginDay: -1,
				
				doctor: {// 医生
					avatar: '',// 头像
					title: '',
					description: ''
				},
				
				description: '',
				
				suitableCrowd: '',
				
				courseNumber: 0,
				courseTime: 0,
				courseDuration: 0
				
				
			}
		},
		mounted() {
			this.getDetail();
		},
		methods: {
			// 图片加载完成显示，防止无图闪烁
			imgLoad(e) {
				var target = e.target;
				target.className = target.className.replace('qjc-hide');
			},
			
			getDetail() {
				var that = this;
				
				courseDetail(this.$route.params.id).then(res => {
					console.log(res)
					
					if(res.errno == 0){
						var data = res.data;
						
						that.videoSrc = data.video;
						that.videoPoster = data.cover;
						that.name = data.name;
						that.beginDay = data.beginDay;
						that.number = data.joinCount;
						that.doctor = data.doctors[0];
						that.description = data.description;
						that.suitableCrowd = data.suitableCrowd;
						that.courseNumber = data.courseNumber;
						that.courseTime = data.courseTime;
						that.courseDuration = data.courseDuration;
						
					}else{
						Toast.fail(res.errmsg);
					}
					
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.detail{
		height: 9.9rem;
		background: url(https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/home_bg.png) no-repeat;
		background-size: 100% 100%;
		padding: 0.4rem 0.8rem;
		overflow-y: auto;
		
		h3,
		dt{
			font-weight: 400;
			font-size: 0.32rem;
			color: #E1E7F5;
		}
		dd{
			font-size: 0.24rem;
			color: #9BA0A8;
			line-height: 0.36rem;
		}
		.top{
			justify-content: flex-start;
			
			p,
			dd{
				font-size: 0.28rem;
				color: #84878F;
			}
			video{
				flex-shrink: 0;
				width: 7.5rem;
				height: 4.5rem;
				margin-right: 0.32rem;
				object-fit: fill;
					
				&:focus{
					border: none;
					outline: none;
				}
			}
			h3{
				font-size: 0.48rem;
				line-height: 0.48rem;
				padding: 0.2rem 0 0.16rem;
			}
			.title{
				margin-bottom: 0.57rem;
			}
			.qjc-flex{
				.head{
					width: 0.72rem;
					height: 0.72rem;
					margin-right: 0.2rem;
				}
				dt{
					font-size: 0.3rem;
					line-height: 0.3rem;
					padding-top: 0.04rem;
				}
				dd{
					font-size: 0.24rem;
					line-height: 0.24rem;
					margin-top: 0.12rem;
				}
			}
			.describe{
				max-height: 1.26rem;
				color: #9BA0A8;
				font-size: 0.28rem;
				line-height: 0.42rem;
				margin-top: 0.2rem;
				overflow: hidden;
				
				&.open{
					max-height: fit-content;
				}
			}
			.toggle{
				display: inline-block;
				font-size: 0.28rem;
				line-height: 0.28rem;
				color: #5FD6FF;
				margin-top: 0.08rem;
				cursor: pointer;
			}
			
			.start{
				top: 0;
				right: 0;
				width: 3.8rem;
				height: 1.02rem;
				line-height: 1.02rem;
				border-radius: 0.08rem;
				color: #5FD6FF;
				font-size: 0.36rem;
				text-align: center;
				background: url(../../../assets/images/dayu_course_start.png);
				background-size: 100% 100%;
				cursor: pointer;
			}
		}
		
		&>dl{
			margin-top: 0.4rem;
			
			dt{
				margin-bottom: 0.08rem;
			}
			dd{
				span{
					margin-right: 1.44rem;
				}
			}
		}
		
	}
</style>
